import React from 'react'
import { Button, FormControl, Grid, Paper, Typography } from '@material-ui/core'
import i18n from '../../../i18n'
import { Field, reduxForm } from 'redux-form'
import PropTypes from 'prop-types'
import { assignPeselNumberFormValidation } from './AssignPeselNumberFormValidation'
import FormTextField from '../../form/FormTextField'
import './style.scss'

let AssignPeselNumberForm = ({ handleSubmit, fetching, invalid }) => {
  return (
    <form onSubmit={handleSubmit}>
      <div>
        <h4>{i18n.t('assignPeselNumber.assignForm.header')}</h4>
      </div>
      <Paper style={{ padding: 16, marginTop: 24 }}>
        <Grid container spacing={2}>
          <Grid item xs={6} md={3}>
            <Typography variant='body2' class='vertical-center'>
              {i18n.t('assignPeselNumber.assignForm.peselNumberLabel')}
            </Typography>
          </Grid>
          <Grid item xs={6} md={9}>
            <div className='form-group'>
              <FormControl>
                <Field
                  name='peselNumber'
                  type='number'
                  component={FormTextField}
                  label={i18n.t(
                    'assignPeselNumber.assignForm.peselNumberLabel'
                  )}
                />
              </FormControl>
            </div>
          </Grid>
        </Grid>
        <div style={{ display: 'flex', justifyContent: 'flex-end' }}>
          <Button disabled={fetching || invalid} type='submit'>
            {i18n.t('assignPeselNumber.assignForm.submitLabel')}
          </Button>
        </div>
      </Paper>
    </form>
  )
}

AssignPeselNumberForm.propTypes = {
  handleSubmit: PropTypes.func.isRequired,
  fetching: PropTypes.bool.isRequired,
  invalid: PropTypes.bool,
}

AssignPeselNumberForm = reduxForm({
  form: 'assignPeselNumber',
  validate: assignPeselNumberFormValidation,
  initialValues: { peselNumber: '' }
})(AssignPeselNumberForm)

export default AssignPeselNumberForm
